<template>
  <div style="margin-bottom: 50px;">

    <el-row>
      <el-col :span="1"><div>&nbsp;</div></el-col>
      <el-col :span="22">
        <!-- dealership info -->
        <el-row style="margin-top: 20px;">
          <el-col :span="24">
            <div>
              <span class="dealer-name">{{dealershipInfo.nameCn}}</span>
              <!-- TODO 后端传输后测试 -->
              <!--<span class="dealer-info">{{ dealershipInfo.networkTypes }}</span>-->
              <span class="dealer-info">{{dealershipInfo.networkTypeName}}</span>
              <span class="verticar-bar" v-if="dealershipInfo.networkTypeName && dealershipInfo.openDate">|</span>
              <!-- 开店日期 -->
              <span class="dealer-info">{{dealershipInfo.openDate}}</span>
              <!--<span class="dealer-info">2017-06-23</span>-->
              <el-button style="float:right;margin-right:0px;width: 160px;text-align: center;" type="primary"
                         @click="seeOrgTree">{{$t('talentpool.queryUserByOutlet')}}</el-button>
            </div>
            <div style="margin-top: 10px;margin-bottom: 25px">
              <!-- 经销商集团名称 -->
              <span class="dealer-group-name">{{ dealershipInfo.parentDealerGroupNameCn }}</span>
              <!--<el-button style="text-align:right; float:right;margin-right:0px;width: 160px;text-align: center;" type="primary"-->
                         <!--@click="exportPositionVacancies()">{{$t('talentpool.exportPositionInfo')}}</el-button>-->
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="1"><div>&nbsp;</div></el-col>
    </el-row>
    <div style="background-color: #F5F5F5">
      <el-row></el-row>
      <el-row class="year-file-row">
        <el-col :span="1"><div>&nbsp;</div></el-col>
        <el-col :span="22">
            <!--<iframe width="100%"-->
                    <!--height="300"-->
                    <!--src="http://joylearning.bmw.bmw.com.cn:5555/#/share/E0BEF98BE/dashboard/ED80724E3"-->
                    <!--frameborder="0"></iframe>-->
          <iframe
            allowFullScreen="true"
            width="100%"
            height="160"
            frameborder="0"
            title=""
            id="iframe"
            :src="ochartIframeUrl">
          </iframe>
        </el-col>
        <el-col :span="1"><div>&nbsp;</div></el-col>
      </el-row>

      <!--部门统计信息-->
      <el-row class="year-file-row">
        <el-col :span="1"><div>&nbsp;</div></el-col>
        <el-col :span="22" style="background: #FFFFFF">
          <el-row>
            <el-col style="text-align:right; float:right; margin-top: 10px;margin-right: 15px;">
              <el-tooltip placement="top-start" effect="light" >
                <div slot="content">{{'关键职位编制参考规则请参见用户管理-职位下载。'}}</div>
                <em class="el-icon-question"></em>
              </el-tooltip>
            </el-col>
          </el-row>
          <!-- dealership 部门信息 -->
          <el-row v-if="dealershipInfo.dealerSize" :gutter="0"
                  class="dep-row">
            <el-col :span="6"
                    :key="'dep-' + index"
                    v-for="(item, index) in depList">
              <!--<el-row style="padding: 15px;"-->
              <!--:style="getDepBorderStyle(index)">-->
              <div class="hoverClass" @click="queryOrgByDepartmengt(item)" style="cursor:pointer">
                <el-row style="padding: 15px;border: 2px solid #cccccc; margin: 5px;">
                  <el-col :span="24"
                          style="text-align: left">
              <span class="dep-name-content"><img alt="" style="width: 30px;height: 30px;margin-right: 5px;"
                                                  :src="item.icon"
                                                  @error="imgError(depList, index)"
                                                  alt=""><span>{{ item.departmentCnName }}</span></span>
                  </el-col>
                  <el-col :span="24">
                    <el-row :gutter="0">
                      <el-col :span="8">
                        <div class="item-number">{{ item.standardNumber }}</div>
                        <div class="item-text">{{$t('talentpool.suggestPeopleNum')}}</div>
                      </el-col>
                      <el-col :span="8">
                        <div class="item-number"
                             style="display: inline-block;"
                             :style="{color: item.departmentVacanciesNumber > 0 ? 'red' : ''}">{{ item.actualNumber }}</div>
                        <div class="item-text">{{$t('talentpool.actualPeopleNum')}}</div>
                      </el-col>
                      <el-col :span="8">
                        <template v-if="(item.departmentVacanciesNumber > 0 && item.positionInfoList.length > 0)">
                          <!--<el-tooltip placement="top">-->
                          <!--<table class="tips-table"-->
                          <!--slot="content">-->
                          <!--<tr>-->
                          <!--<th>{{$t('talentpool.jobCode')}}</th>-->
                          <!--&lt;!&ndash;<th>Job Code</th>&ndash;&gt;-->
                          <!--<th>{{$t('talentpool.kongGangNum')}}</th>-->
                          <!--</tr>-->
                          <!--<tr :key="idx"-->
                          <!--v-for="(it, idx) in item.positionInfoList">-->
                          <!--<td>{{ it.positionCodeAndName }}</td>-->
                          <!--&lt;!&ndash;<td>{{ it.positionCode }}</td>&ndash;&gt;-->
                          <!--<td>{{ it.positionVacanciesNumber }}</td>-->
                          <!--</tr>-->
                          <!--</table>-->
                          <!--<div class="item-number"-->
                          <!--style="display: inline-block; color:red;">{{ item.departmentVacanciesNumber }}</div>-->
                          <!--</el-tooltip>-->
                          <div class="item-number"
                               style="display: inline-block; color:red;">{{ item.departmentVacanciesNumber }}</div>
                        </template>
                        <template v-else>
                          <div class="item-number"
                               style="display: inline-block;">{{ item.departmentVacanciesNumber }}</div>
                        </template>
                        <div class="item-text">{{$t('talentpool.kongGangNum')}}</div>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row v-else>
            <div style="text-align: center;margin-bottom: 30px;">{{noDealerSize}}</div>
          </el-row>
        </el-col>
        <el-col :span="1"><div>&nbsp;</div></el-col>
      </el-row>

      <!-- 年度归档 -->
      <el-row class="year-file-row">
        <el-col :span="1"><div>&nbsp;<br/></div></el-col>
        <el-col :span="22"  style="background: #FFFFFF">
          <h3>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('talentpool.annualFiling')}}</h3>
        </el-col>
        <el-col :span="1"><div>&nbsp;</div></el-col>
      </el-row>

      <el-row>
        <el-col :span="1"><div>&nbsp;</div></el-col>
        <el-col :span="22"  style="background: #FFFFFF">
          <el-row class="year-file-dtl-row">
            <el-col style="width: 40px"><div>&nbsp;</div></el-col>
            <template v-for="(item, index) in yearFileList">
              <el-col :span="7"
                      :key="index"
                      class="year-file-col"
                      style="background-color: rgba(28, 134, 238, 1);">
                <div class="generate-date-text">{{$t('talentpool.createDate')}}</div>
                <div class="generate-date">{{item.carryoverTime?item.carryoverTime.substring(0,10) : ''}}</div>
                <div class="download-button">
                  <el-button type="text"
                             @click="openOrgTree(item)"><span class="download-btn-text">{{$t('talentpool.export')}}</span></el-button>
                </div>
              </el-col>
              <el-col style="width: 40px"><div>&nbsp;</div></el-col>
            </template>
          </el-row>
          <el-row v-if="yearFileList.length <= 0">
            <div style="text-align: center;margin-bottom: 50px;">{{noHistoricalFiling}}</div>
          </el-row>
        </el-col>
        <el-col :span="1"><div>&nbsp;</div></el-col>
      </el-row>
      <el-row class="year-file-row">
      </el-row>
    </div>

    <!-- 年度归档dialog-->
    <el-dialog :title="$t('talentpool.annualFiling')"
               :visible.sync="dialogVisible"
               width="85%"
               :close-on-click-modal="false"
               height="600"
               top="1vh">
      <div style="margin-top: -50px">
      <!-- :show-close="false"-->
      <org-tree-two :isPrint="true"
                    :queryParams="queryParams"></org-tree-two>
      <el-form>
        <el-row>
          <!--<el-col :span="21">-->
            <!--<el-form-item></el-form-item>-->
          <!--</el-col>-->
          <el-col style="text-align:right; float:right;" :gutter="20">
            <el-button size="mini" type="primary" @click="dialogVisible = false">{{$t('talentpool.takeAway')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
      </div>
    </el-dialog>

    <!-- 年度归档dialog-->
    <el-dialog title=""
               :visible.sync="isShowOrgByDepDialog"
               width="85%"
               :close-on-click-modal="false"
               height="600"
               top="1vh">
      <!-- :show-close="false"-->
      <div style="margin-top: -50px">
      <org-tree-two :queryParams="queryParams"></org-tree-two>
      <el-form>
        <el-row>
          <el-col style="text-align:right; float:right;" :gutter="20">
            <el-button size="mini" type="primary" @click="isShowOrgByDepDialog = false">{{$t('talentpool.takeAway')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'org-tree-one',
  components: {
    'org-tree-two': () => import('./org-tree-two')
  },
  data () {
    return {
      dealershipInfo: {
        'bbaNo': '',
        // 品牌
        'brandNames': '',
        'dealerSize': '',
        // 经销商名称
        'nameCn': '',
        'nameEn': '',
        // 经销商类型
        'networkTypes': '',
        // NSC NO
        'nscNo': '',
        // 经销商ID
        'orgId': '',
        // outletList
        'outletList': [],
        // 城市
        'regionName': '',
        // orgCode
        'orgCode': ''
      },
      depList: [],
      // 年度归档
      yearFileList: [],
      dialogVisible: false,
      queryParams: {},
      ochartIframeUrl: '',
      noDealerSize:'',
      noHistoricalFiling:'',

      // 按部门查看组织架构
      isShowOrgByDepDialog: false
    }
  },
  methods: {
    /**
     * 渲染border
     * @param index
     * @returns {*}
     */
    // getDepBorderStyle (index) {
    //   let order = index + 1
    //   if (order % 4 === 1) {
    //     return order > 4 ? {
    //       'border-top-color': '#f2f2f2',
    //       'border-top-style': 'solid',
    //       'border-top-width': '1px'
    //     } : {}
    //   } else {
    //     return order > 4 ? {
    //       'border-top-color': '#f2f2f2',
    //       'border-top-style': 'solid',
    //       'border-top-width': '1px',
    //       'border-left-color': '#f2f2f2',
    //       'border-left-style': 'solid',
    //       'border-left-width': '1px'
    //     } : {
    //       'border-left-color': '#f2f2f2',
    //       'border-left-style': 'solid',
    //       'border-left-width': '1px'
    //     }
    //   }
    //   // if (order % 4 === 2) {
    //   //   return order > 4 ? {
    //   //     'border-top-color': '#f2f2f2',
    //   //     'border-top-style': 'solid',
    //   //     'border-top-width': '1px',
    //   //     'border-left-color': '#f2f2f2',
    //   //     'border-left-style': 'solid',
    //   //     'border-left-width': '1px'
    //   //   } : {
    //   //     'border-left-color': '#f2f2f2',
    //   //     'border-left-style': 'solid',
    //   //     'border-left-width': '1px'
    //   //   }
    //   // }
    //   // if (order % 4 === 3) {
    //   //   return order > 4 ? {
    //   //     'border-top-color': '#f2f2f2',
    //   //     'border-top-style': 'solid',
    //   //     'border-top-width': '1px',
    //   //     'border-left-color': '#f2f2f2',
    //   //     'border-left-style': 'solid',
    //   //     'border-left-width': '1px'
    //   //   } : {
    //   //     'border-left-color': '#f2f2f2',
    //   //     'border-left-style': 'solid',
    //   //     'border-left-width': '1px'
    //   //   }
    //   // }
    //   // if (order % 4 === 0) {
    //   //   return order > 4 ? {
    //   //     'border-top-color': '#f2f2f2',
    //   //     'border-top-style': 'solid',
    //   //     'border-top-width': '1px',
    //   //     'border-left-color': '#f2f2f2',
    //   //     'border-left-style': 'solid',
    //   //     'border-left-width': '1px'
    //   //   } : {
    //   //     'border-left-color': '#f2f2f2',
    //   //     'border-left-style': 'solid',
    //   //     'border-left-width': '1px'
    //   //   }
    //   // }
    // },
    // 获取dealership info

    getDealershipInfo (orgId) {
      this.$request.post(
        '/talent/positionstandardvalue/queryOutLetByDealerShipId', orgId ? { orgId: orgId } : {}
      ).then((res) => {
        this.dealershipInfo = res
        if(!this.dealershipInfo.dealerSize){
          this.noDealerSize= '暂未设置组织架构模板'
        }
        // 加载iframe
        this.$nextTick(function () {
          this.initIframe()
        })
      }).catch((error) => {
        // this.$message.error(error)
      })
    },

    // TODO 建议值维护页面跳转到本页面时，需要传orgId和dealerSize两个参数到后台（待完成）
    getAllDepartmentList (orgId, dealerSize) {
      this.$request.post(
        '/talent/positionstandardvalue/countDepartmentInfo', orgId ? { orgId: orgId, dealerSize: dealerSize } : {}
      ).then((res) => {
        this.depList = res
      }).catch((error) => {
        // this.$message.error(error)
      })
    },

    // 获取年度归档信息
    getYearFileList (orgId) {
      this.$request.get(
        '/talent/carryoverRecord/getList', orgId ? { orgId: orgId }:{}).then((res) => {
        let _this = this
        _this.yearFileList = []
        res.forEach(function (item) {
          if (item.isDefaultShow !== '1') {
            _this.yearFileList.push(item)
          }
        })
        if(_this.yearFileList.length <= 0){
          _this.noHistoricalFiling = '暂无历史归档'
        }
      }).catch((error) => {
        // this.$message.error(error)
      })
    },

    imgError (depList, index) {
      this.depList[index].icon = require('@/assets/img/dep-default.png')
      this.$forceUpdate()
    },

    seeOrgTree () {
      this.queryParams = undefined
      this.$emit('switchComponent', 'org-tree-two')
    },

    // 查询年度归档
    openOrgTree (item) {
      this.queryParams = {}
      // 结转id
      this.queryParams['carryoverId'] = item.id
      this.$nextTick(() => {
        this.$eventHub.$emit('clickCarryoverRecord', '')
        this.dialogVisible = true
      })
    },
    // 按部门查找组织架构
    queryOrgByDepartmengt (item) {
      this.queryParams = {}
      // 部门树id和部门名称
      this.queryParams['departmentId'] = item.departmentTreeId
      this.queryParams['departmentCnName'] = item.departmentCnName
      this.$nextTick(() => {
        this.$eventHub.$emit('clickCarryoverRecord', '')
        this.isShowOrgByDepDialog = true
      })
    },

    // 导出空岗信息
    exportPositionVacancies () {
      this.$request.downloadRm('/talent/positionstandardvalue/exportPositionVacancies', '空岗信息', this.$route.query.orgId ? { orgId: this.$route.query.orgId, dealerSize: this.$route.query.dealerSize } : {})
    },
    // 初始化页面调用的方法
    initMethod () {
      this.noDealerSize = ''
      this.ochartIframeUrl = ''
      this.noHistoricalFiling = ''
      // if (this.$route.query.orgId && this.$route.query.dealerSize) {
      if (this.$route.query.orgId) {
        this.getDealershipInfo(this.$route.query.orgId)
        this.getAllDepartmentList(this.$route.query.orgId, this.$route.query.dealerSize)
        // 获取年度归档信息
        this.getYearFileList(this.$route.query.orgId)
      } else {
        this.getDealershipInfo()
        this.getAllDepartmentList()
        // 获取年度归档信息
        this.getYearFileList()
      }
      console.log(this.$route.query.orgId)
    },
    initIframe () {
      this.ochartIframeUrl = ''
      if(!this.dealershipInfo.orgId){
        return;
      }
      let dashboardStyle = '&copyright=false&scrollable=false&chartAccessible=false&padding=0 0 0 0'

      // let url = 'https://testjoylearning.bmw.com.cn:5500/#/share/EE7BB5481/infographic/E22D894E1'
      //let url = 'https://testjoylearning.bmw.com.cn:5500/#/private/share/EE7BB5481/infographic/E22D894E1'
      // let search = '?where=[{"show":true,"datasetId":22,"fieldName":"parent_org_id_11_12","use":"checkbox","kind":"function","op":"in","args":[{"kind":"field","op":"parent_org_id_11_12","dataset":22},{"kind":"constant","op":["'+this.dealershipInfo.orgId+'"],"dataset":22}],"field":{"originType":"integer","config":{},"fieldName":"parent_org_id_11_12","basicType":"string","defaultAggrType":"count","hsVersion":4,"oriLabel":"parent_org_id","oriName":"parent_org_id_11","nativeType":"BIGINT","visible":true,"datasetId":22,"label":"parent_org_id","suggestedTypes":["number","string"],"detectedType":"integer","minValue":0,"maxValue":0,"fieldType":"string","dataUniq":["'+this.dealershipInfo.orgId+'"]},"dataset":22}]&copyright=false&scrollable=false&chartAccessible=false&padding=0 0 0 0'
      //let search = '?where=[{"args":[{"kind":"field","op":"u_16911fc2843df8b5_0_30","dataset":36},{"kind":"constant","op":["'+this.dealershipInfo.orgId+'"],"dataset":36}],"op":"in","fieldName":"u_16911fc2843df8b5_0_30","field":{"label":"org_id_1","config":{"seperator":" ","dialectName":"EngineDialect"},"oriName":"u_16911fc2843df8b5_0","visible":true,"dataUniq":["'+this.dealershipInfo.orgId+'"],"maxValue":0,"minValue":0,"oriLabel":"parent_org_id","basicType":"string","datasetId":36,"fieldName":"u_16911fc2843df8b5_0_30","fieldType":"string","hsVersion":8,"nativeType":"text","originType":"string","detectedType":"number","suggestedTypes":["number","string"],"defaultAggrType":"count"},"use":"checkbox","kind":"function","show":true,"datasetId":36,"dataset":36},{"show":true,"datasetId":37,"fieldName":"u_0b5f1f4480ed5870_0_31","use":"checkbox","kind":"function","op":"in","args":[{"kind":"field","op":"u_0b5f1f4480ed5870_0_31","dataset":37},{"kind":"constant","op":["'+this.dealershipInfo.orgId+'"],"dataset":37}],"field":{"originType":"string","config":{"seperator":" ","dialectName":"EngineDialect"},"fieldName":"u_0b5f1f4480ed5870_0_31","basicType":"string","defaultAggrType":"count","hsVersion":10,"oriLabel":"dealer_id","oriName":"u_0b5f1f4480ed5870_0","nativeType":"text","visible":true,"datasetId":37,"label":"org_id_c","suggestedTypes":["number","string"],"detectedType":"number","minValue":0,"maxValue":0,"fieldType":"string","dataUniq":["'+this.dealershipInfo.orgId+'"]},"dataset":37}]&copyright=false&scrollable=false&chartAccessible=false&padding=0 0 0 0'
      //let search = '?where=[{"args":[{"kind":"field","op":"u_0b5f1f4480ed5870_0_31","dataset":37},{"kind":"constant","op":["orgIdReplace"],"dataset":37}],"op":"in","fieldName":"u_0b5f1f4480ed5870_0_31","field":{"label":"org_id_c","config":{"seperator":" ","dialectName":"EngineDialect"},"oriName":"u_0b5f1f4480ed5870_0","visible":true,"dataUniq":["orgIdReplace"],"basicType":"string","datasetId":37,"fieldName":"u_0b5f1f4480ed5870_0_31","fieldType":"string","hsVersion":10,"nativeType":"text","originType":"string","detectedType":"number","suggestedTypes":["number","string"],"defaultAggrType":"count"},"use":"checkbox","kind":"function","show":false,"datasetId":37,"dataset":37},{"args":[{"kind":"field","op":"u_16911fc2843df8b5_0_30_36_50","dataset":58},{"kind":"constant","op":["orgIdReplace"],"dataset":58}],"op":"in","fieldName":"u_16911fc2843df8b5_0_30_36_50","field":{"label":"org_id_1","config":{"seperator":" ","dialectName":"EngineDialect"},"oriName":"u_16911fc2843df8b5_0_30_36","visible":true,"dataUniq":["orgIdReplace"],"basicType":"string","datasetId":58,"fieldName":"u_16911fc2843df8b5_0_30_36_50","fieldType":"string","hsVersion":1,"nativeType":"text","originType":"string","detectedType":"number","suggestedTypes":["number","string"],"defaultAggrType":"count"},"showTag":false,"use":"checkbox","kind":"function","show":false,"datasetId":58,"dataset":58}]&copyright=false&scrollable=false&chartAccessible=false&padding=0 0 0 0'
      this.ochartIframeUrl = window.SITE_CONFIG['ochartDashboardOneUrl'].replace(/orgIdReplace/g, this.dealershipInfo.orgId)+dashboardStyle
      console.log(this.ochartIframeUrl)
    }
  },
  mounted () {
    this.ochartIframeUrl = ''
    this.initMethod()
    this.$eventHub.$on(this.GLOBAL.ORG_TREE_ONE, (data) => {
      this.initMethod()
    })
  },
  beforeDestroy  () {
    this.$eventHub.$off(this.GLOBAL.ORG_TREE_ONE)
  }
}
</script>

<style lang="css" scoped>
/* 经销商名称 */
.dealer-name {
  font-size: 23px;
  font-weight: bold;
  margin-right: 15px;
}
/* 经销商集团名称 */
.dealer-group-name {
  font-size: 16px;
}
/* 经销商信息 */
.dealer-info {
  font-size: 16px;
}
/* 竖杠 */
.verticar-bar {
  font-size: 15px;
  margin: 0 4px;
}
/* 按钮 */
/*.org-button {*/
  /*position: absolute;*/
  /*right: 0;*/
  /*bottom: 0;*/
  /*text-align: right;*/
/*}*/
/* 嵌入网页 */
.position-statistic {
  height: 180px;
  background-color: #ccc;
  margin-top: 20px;
}
.dep-row {
  border: 0px solid rgba(192, 196, 204, 0.2);
  padding: 10px;
}
/* 人数 */
.item-number {
  font-size: 20px;
  font-weight: bold;
  margin-top: 18px;
}
/* 人数下面的文本 */
.item-text {
  font-weight: bold;
  font-size: 12px;
  margin-top: 12px;
}
/* 部门 name 和 icon */
.dep-name-content {
  font-size: 15px;
  font-weight: bold;
}
/* 部门icon */
.dep-icon {
  margin-right: 8px;
  font-size: 22px;
  margin-left: 20px;
  font-weight: bold;
  color: #376ad4;
}
/* 年度归档 */
.year-file-row {
  margin-top: 30px;
  margin-left: 0;
  margin-right: 0;
}
.year-file-dtl-row {
  margin-bottom: 20px;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.year-file-col {
  border: 1px solid rgba(28, 134, 238, 1);
  padding: 10px;
  border-radius: 4px;
  text-align: left;
}
.generate-date-text {
  color: white;
  font-size: 20px;
  font-weight: bold;
  padding: 10px;
}
.generate-date {
  color: white;
  font-size: 16px;
  font-weight: bold;
  padding: 10px;
}
.download-button {
  color: white;
  text-align: right;
  padding: 10px;
}
.download-btn-text {
  color: white;
  cursor: pointer;
  text-decoration: underline;
}
/* 有空岗人数时的table样式 */
.tips-table,
.tips-table > tr > th,
.tips-table > tr > td {
  padding: 5px;
  border: 1px solid #515151;
  text-align: center;
  border-collapse: collapse;
  border-spacing: 0px;
}
.hoverClass :hover {
  background: #1C86EE;
  color: white;
}
</style>
